// src/components/JobDetails.js
import React, { useEffect, useState } from 'react';
import { getJobById } from '../../../../services/JobService';
import { useLocation } from 'react-router-dom';

const JobDetails = () => {
    const location = useLocation();
    const [viewJob, setViewJob] = useState({
        jobTitle: '',
        slug: '',
        ppe: '',
        status: 'active',
        hazards: [{ hazard: '', description: '', controls: '' }],
    });
    useEffect(() => {
        const apiCall = async () => {
            try {
                if(location.state != null){
                    const job = await getJobById(location.state.id);
                    setViewJob(job);
                }
            } catch (error) {
                console.error(`Error fetching job with id`, error);
            }
        }
        apiCall()
    }, [])
    return (
        <div>
            <h3>{viewJob.jobTitle}</h3>
            <p>Slug: {viewJob.slug}</p>
            <p>Slug: {viewJob.ppe}</p>
            <p>Status: {viewJob.status}</p>
            <h3>Hazards</h3>
            {viewJob.hazards.map((hazard, index) => (
                <div key={index}>
                    <h4>{hazard.hazard}</h4>
                    <p>{hazard.description}</p>
                    <p>{hazard.controls}</p>
                </div>
            ))}
        </div>
    );
}

export default JobDetails;
